import type { NavItem } from '@mbbe/ui';

type Language = 'tr' | 'en';
type Translate = (key: string) => string;

/** Labels of the platform-expansion entries (docs/platform-expansion-20261015.md, "Public website"). */
const PLATFORM_LABELS: Record<Language, { blog: string; demos: string }> = {
  tr: { blog: 'Blog', demos: 'Demolar' },
  en: { blog: 'Blog', demos: 'Demos' },
};

/** Header and footer navigation of the public website. */
export function publicNavigation(language: Language, t: Translate = (key) => key): { primary: NavItem[]; footer: NavItem[] } {
  const labels = PLATFORM_LABELS[language];
  return {
    primary: [
      { name: t('nav_home'), path: '/' },
      { name: t('nav_services'), path: '/services' },
      { name: t('nav_portfolio'), path: '/portfolio' },
      { name: labels.demos, path: '/demos' },
      { name: labels.blog, path: '/blog' },
      { name: t('nav_pricing'), path: '/pricing' },
      { name: t('nav_contact'), path: '/contact' },
    ],
    footer: [
      { name: t('nav_home'), path: '/' },
      { name: t('nav_portfolio'), path: '/portfolio' },
      { name: labels.demos, path: '/demos' },
      { name: labels.blog, path: '/blog' },
      { name: t('nav_services'), path: '/services' },
      { name: t('nav_contact'), path: '/contact' },
      { name: 'KVKK Aydınlatma Metni', path: '/kvkk-aydinlatma-metni' },
      { name: 'Gizlilik Politikası', path: '/gizlilik-politikasi' },
    ],
  };
}
